import { render, staticRenderFns } from "./InvoiceCalculation.vue?vue&type=template&id=5855cd81&scoped=true&"
import script from "./InvoiceCalculation.vue?vue&type=script&lang=js&"
export * from "./InvoiceCalculation.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCalculation.vue?vue&type=style&index=0&id=5855cd81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5855cd81",
  null
  
)

export default component.exports